<!--
   Created by qing on 2022/6/9 下午9:56
   Des:
-->
<template>

  <div>
    <van-cell class="form-link-query-item">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>

        <div style="width: 100%; display:flex; justify-content: flex-end;">
          <el-button
            icon="el-icon-refresh"
            type="text"
            :disabled="fetchLoading"
            @click="tableDataFetch">
            手动刷新数据
          </el-button>
        </div>

        <div class="form-link-query-container" v-loading="fetchLoading">

          <template v-if="current.linkShowStyle === 'TIME-3'">
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in showDataList"
                :key="activity.instanceId">
                <div @click="rowClick(activity)" style="cursor: pointer;">
                  <div class="title">
                    <span style="margin-right: 10px;">{{actionFormatTime(activity.timestamp)}}</span>{{activity.linkTitle}}
                  </div>
                  <div class="des">
                    {{activity.linkDetail}}
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
            <el-button
              type="text"
              class="check-all-btn"
              v-if="totalCount> 0"
              @click="checkAll">
              查看全部{{totalCount}}条 >>
            </el-button>
          </template>

          <div class="card-container" v-else-if="['LIST'].includes(current.linkShowStyle)">
            <div
              class="card-container-item"
              v-for="(activity, index) in showDataList"
              :key="activity.instanceId"
              @click="rowClick(activity)">
              <i class="el-icon-document"></i>
              <div>
                <div class="title">
                  {{activity.linkTitle}}
                </div>
                <div class="des">
                  {{activity.linkDetail}}
                </div>
                <div class="time">
                  {{actionFormatTime(activity.timestamp)}}
                </div>
              </div>
            </div>
            <el-button
              type="text"
              style="margin-left: 20px"
              v-if="totalCount> 0"
              @click="checkAll">
              查看全部{{totalCount}}条 >>
            </el-button>
          </div>

          <div v-else>
            <AllAvailable
              v-if="headerList && headerList.length"
              ref="AllAvailable"
              :header="headerList"
              :sortable="false"
              :uploadChangeWidth="true"
              @rowClick="rowClick"
              :row-style="rowStyle"
              :cell-style="cellStyle"
              :header-cell-style="headerCellStyle"
              :borderColor="current.styleInfo ? actionHexToRgba(current.styleInfo.mainColor, 0.5) : ''"
              :tableData="showDataList"
              :has-index="true">
            </AllAvailable>
          </div>
        </div>
      </template>
    </van-cell>

    <FormViewDataPopup
      v-if="current.detailViewId && current.detailViewId !== 'dataHandle'"
      ref="formViewDataDetail"
      :is-link="current.parent.isLink"
      :appId="current.dataAppId"
      :formId="current.dataFormId"
      :view-id="current.detailViewId"
      @saveFormDataComplete="refreshData"
      @deleteComplete="refreshData">
    </FormViewDataPopup>

    <FormDataPopup
      v-else
      ref="formDataDetail"
      :is-link="current.parent.isLink"
      :appId="current.dataAppId"
      :formId="current.dataFormId"
      :viewType="3"
      @saveFormDataComplete="refreshData"
      @deleteComplete="refreshData">
    </FormDataPopup>


    <van-popup
      class="form-link-query-all-data"
      v-model="dialogVisible"
      position="bottom"
      get-container="body"
      close-on-popstate
      :style="{ height: '90%' }">
      <div class="form-link-query-container">
        <template v-if="current.linkShowStyle === 'TIME-3' && current.pcShowTable === 'NO'">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in dataList"
              :key="activity.instanceId">
              <div @click="rowClick(activity)" style="cursor: pointer;">
                <div class="title">
                  <span style="margin-right: 10px;">{{actionFormatTime(activity.timestamp)}}</span>{{activity.linkTitle}}
                </div>
                <div class="des">
                  {{activity.linkDetail}}
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </template>

        <div class="card-container" v-else-if="['LIST'].includes(current.linkShowStyle) && current.pcShowTable === 'NO'">
          <div
            class="card-container-item"
            v-for="(activity, index) in dataList"
            :key="activity.instanceId"
            @click="rowClick(activity)">
            <i class="el-icon-document"></i>
            <div>
              <div class="title">
                {{activity.linkTitle}}
              </div>
              <div class="des">
                {{activity.linkDetail}}
              </div>
              <div class="time">
                {{actionFormatTime(activity.timestamp)}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
  import {current} from './mixin'
  import {accurateFormatDate, arraySort, formatDate, hexToRgb, hexToRgba} from '../../../assets/js/Untis'
  import {FORM_STATUS__EDIT} from "../types";
  import AllAvailable from "../../component/AllAvailable";
  import ViewSet from "../../RyView";
  import FormDataPopup from "../../component/FormDataPopup";
  import FormViewDataPopup from "../../component/FormViewDataPopup";

  export default {
    mixins: [current],
    data() {
      return {
        fetchLoading: false,
        dataList: [],
        showDataList: [],
        headerList: [],
        totalCount: 0,
        dialogVisible: false,
      }
    },
    components: {
      AllAvailable,
      FormDataPopup,
      FormViewDataPopup
    },
    computed: {},
    created() {
      if (this.current.root.status !== FORM_STATUS__EDIT) {
        document.addEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)

        if (this.current.detailViewId && this.current.detailViewId !== 'dataHandle') {
          this.viewSet = ViewSet.init({
            userId: this.$store.getters.userId,
            formId: this.current.dataFormId,
            viewId: this.current.detailViewId,
            companyId: this.$store.getters.currentCompanyId,
            appId: this.current.dataAppId
          })
          // 还原viewSet结构
          const formSet = this.current.root
          this.$store.dispatch('actionFetchFormViewOutDetail', {
            companyId: formSet.companyId,
            appId: formSet.appId, //appId
            formId: this.current.dataFormId,
            viewId: this.current.detailViewId
          }).then(resultObject => {
            this.viewSet.setConf(resultObject)
          })
        }
      }
      this.tableDataFetch()
    },
    mounted() {
    },
    destroyed() {
      document.removeEventListener('FORM_FIELD_DATA_CHANGE', this.formFieldDataChange)
    },
    methods: {

      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      formatTime(d) {
        console.log('formatTime', formatDate(d)('yyyy-MM-dd'))
        return formatDate(d)('yyyy-MM-dd')
      },
      tableDataFetch() {
        const formSet = this.current.root
        this.fetchLoading = true
        this.$store.dispatch('actionFormLinkQueryData', {
          companyId: formSet.companyId,
          appId: formSet.appId, //appId
          formId: formSet.formId,  //表单的Id
          fieldId: this.current.dataId,
          data: formSet.getValues()
        }).then(res => {
          this.headerList.splice(0, this.headerList.length)
          res.headerList.forEach(item  => {
            this.headerList.push({
              ...item,
              headerTitle: item.fieldTitle,
              show: this.current.showFieldIdList.includes(item.dataId)
            })
          })
          this.dataList = res.dataList
          this.totalCount = res.totalCount
          this.dataList.sort(arraySort("timestamp", false))
          if (this.current.linkShowStyle === 'TIME-3') {
            this.showDataList = this.dataList.slice(0, 3)
          } else if (this.current.linkShowStyle === 'LIST') {
            const num = this.current.listShowNumber < 1 ? 1 : this.current.listShowNumber > 20 ? 20 : this.current.listShowNumber
            this.showDataList = this.dataList.slice(0, num)
          } else {
            this.showDataList = this.dataList
          }
          console.log('res', res, this.headerList, this.dataList)
        }).catch(console.error)
          .finally(() => {
            this.fetchLoading = false
          })
      },

      formFieldDataChange(e) {

        if (e.detail) {
          const {
            fieldId,
            formId,
            rowIdx
          } = e.detail
          if (formId === this.current.root.formId && this.current.refreshFieldIdList.includes(fieldId)) {
            this.tableDataFetch()
          }
        }
      },

      rowStyle({row, rowIndex, columnIndex }) {
        const tableSetting = this.current.styleInfo || {}
        if (rowIndex % 2 === 1) {
          return {
            background: tableSetting ? hexToRgba(tableSetting.mainColor, 0.2) : '',
            color: tableSetting ? tableSetting.contentColor : ''
          }
        } else {
          return {
            background: 'transparent',
            color: tableSetting ? tableSetting.contentColor : ''
          }
        }
      },
      headerRowStyle({row, rowIndex}) {
        // return {
        //   background: this.themeColor
        // }
      },
      cellStyle({row, rowIndex, columnIndex }) {
        const tableSetting = this.current.styleInfo || {}
        return {
          textAlign: tableSetting ? tableSetting.alignment : '',
          borderColor: tableSetting ? hexToRgba(tableSetting.mainColor, 0.5) : '',
        }
      },

      headerCellStyle() {
        const tableSetting = this.current.styleInfo || {}
        return {
          background: tableSetting ? tableSetting.mainColor : '',
          borderBottomColor: tableSetting ? hexToRgba(tableSetting.mainColor, 0.2) : '',
          textAlign: tableSetting ? tableSetting.alignment : '',
          color: tableSetting ? tableSetting.headerColor : ''
        }
      },
      rowClick(row) {
        let index = 0
        for (let i = 0; i < this.dataList.length; i++) {
          if (this.dataList[i].instanceId === row.instanceId) {
            index = i
            break
          }
        }
        console.log('rowClick', this.current.detailViewId, this.$refs.formViewDataDetail)
        if (this.current.detailViewId && this.current.detailViewId !== 'dataHandle') {

          // 数据视图详情
          if (this.$refs.formViewDataDetail) {
            this.$refs.formViewDataDetail.open({
              viewId: this.current.detailViewId,
              instanceId: row.instanceId,
              index: index,
              dataList: this.dataList,
              stepId: row.stepId,
              canEdit: this.viewSet ? !this.viewSet.forbiddenEdit : false,
              showFields: [],
              hasFormBtnList: true,
              isShowLog: this.viewSet.showFlowLog !== 'NO',
              isDynamic: this.viewSet.showHistory !== 'NO',
              showApply: this.viewSet.showApproval !== 'NO',
              showComment: this.viewSet.showComment !== 'NO',
              readonlyFields: this.viewSet.notAllowEditFieldList,
              readonlyAll: this.viewSet.dataReadOnly,
              allowDelete: this.viewSet.allowDelete
            })
          }
        } else {
          // 管理数据详情
          if (this.$refs.formDataDetail) {
            this.$refs.formDataDetail.open(row.instanceId, index, this.dataList)
          }
        }

      },

      refreshData() {
        this.tableDataFetch()
      },
      checkAll() {
        this.dialogVisible = true
      },
      actionHexToRgba(hex, opacity) {
        return hexToRgba(hex, opacity)
      }
    }
  }
</script>

<style lang="less">

  .form-link-query-item {
    width: 100%;

    >.van-cell__title {
      width: 100%;

      >.van-cell__label {
        width: 100%;
      }
    }

    .form-link-query-container {
      width: 100%;
      position: relative;

      .check-all-btn {
        padding: 0 20px;
        margin-left: 20px;
      }

      .el-timeline {
        padding: 0 20px;
      }

      .el-timeline-item {

        &:last-child {
          padding-bottom: 0;
        }
      }

      .el-timeline-item__content {

        > div {
          height: auto;
          line-height: initial;
        }

        .title {
          margin-bottom: 10px;
          color: #6d6d6d;
        }

        .des {
          font-weight: 500;
        }
      }

      .card-container {
        padding: 0 20px;

        .card-container-item {
          display: flex;
          margin-bottom: 10px;
          cursor: pointer;

          i {
           font-size: 18px;
            margin-top: 2px;
            margin-right: 10px;
          }

          >div {
            height: auto;
            line-height: initial;
          }

          .title {
            margin-bottom: 10px;
            color: #6d6d6d;
          }

          .des {
            font-weight: 500;
            margin-bottom: 10px;
          }

          .time {
            color: #6d6d6d;
          }
        }
      }
    }
  }

  .form-link-query-all-data {

    > .form-link-query-container {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: auto;
      padding: 20px 0;

      .el-timeline {
        padding: 0 20px;
      }

      .el-timeline-item {

        &:last-child {
          padding-bottom: 0;
        }
      }

      .el-timeline-item__content {

        > div {
          height: auto;
          line-height: initial;
        }

        .title {
          margin-bottom: 10px;
          color: #6d6d6d;
        }

        .des {
          font-weight: 500;
        }
      }

      .card-container {
        padding: 0 20px;

        .card-container-item {
          display: flex;
          margin-bottom: 10px;
          cursor: pointer;

          i {
            font-size: 18px;
            margin-top: 2px;
            margin-right: 10px;
          }

          >div {
            height: auto;
            line-height: initial;
          }

          .title {
            margin-bottom: 10px;
            color: #6d6d6d;
          }

          .des {
            font-weight: 500;
            margin-bottom: 10px;
          }

          .time {
            color: #6d6d6d;
          }
        }
      }
    }
  }
</style>
